import React from 'react';
import AOS from 'aos';
AOS.init();



const hero = () => {
	return(
		<div className="container">
			<div className="row">
				<div className="col-md-12 text-center">
	                <h2>My Resume</h2>
	                <div className="space-border"></div>
	            </div>
			</div>
			<div className="row gh-5">

				<div className="col-lg-6"
                    data-aos="fade-up"
                        data-aos-once="true"
                    >
                    <div className="p-4">
                        <h3 className="s_border">Experiences</h3>
                        <ul className="d_timeline">
                        <li className="d_timeline-item">
                                <h3 className="d_timeline-title">2023-now</h3>
                                <p className="d_timeline-text">
                                	<span className="d_title">Senior  Backend developer</span>
                                	<span className="d_company">Cybersync Technologiesy</span>
                                	Web and apps backend developer using Node js express js and provideing different database services including MySql,Postgresql.
                                </p>
                            </li>
                            <li className="d_timeline-item">
                                <h3 className="d_timeline-title">2022-2023</h3>
                                <p className="d_timeline-text">
                                	<span className="d_title">Web  &amp; Native app frontend developer</span>
                                	<span className="d_company">BitLogicx Software company</span>
                                	Web development along with flutter native apps.
                                </p>
                            </li>
                            <li className="d_timeline-item">
                                <h3 className="d_timeline-title">2020 - 2022</h3>
                                <p className="d_timeline-text">
                                	<span className="d_title">Senior web developer</span>
                                	<span className="d_company"></span>
                                	Web development using advance technologies and frameworks like react js.
                                </p>
                            </li>
                            <li className="d_timeline-item">
                                <h3 className="d_timeline-title">2018 - 2020</h3>
                                <p className="d_timeline-text">
                                	<span className="d_title">Web developer</span>
                                	<span className="d_company">Exarth software company</span>Web front-end development using best practices of HTML5,CSS3,Bootstrap,Javascript
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="col-lg-6" 
                    data-aos="fade-up"
                        data-aos-once="true"
                    >
                    <div className="p-4">
                        <h3 className="s_border">Education</h3>
                        <ul className="d_timeline">
                            <li className="d_timeline-item">
                                <h3 className="d_timeline-title">2018 - 2022</h3>
                                <p className="d_timeline-text">
                                	<span className="d_title">Bachlers in Software Engineering</span>
                                	<span className="d_company">COMSATS University Islamabad, Abbottabad Campus</span>One of the top IT university in Pakistan.Securing 2.89 CGPA(73%) in Software Engineering.
                                </p>
                            </li>
                            <li className="d_timeline-item">
                                <h3 className="d_timeline-title">2016 - 2018</h3>
                                <p className="d_timeline-text">
                                	<span className="d_title">Intermediate</span>
                                	<span className="d_company">Government Degree Collage Gullabad</span>Intermediate with securing 74% marks.
                                </p>
                            </li>
                            <li className="d_timeline-item">
                                <h3 className="d_timeline-title">2014 - 2016</h3>
                                <p className="d_timeline-text">
                                	<span className="d_title">University public School</span>
                                	<span className="d_company">University of Malakand</span>Matriculation with securing 86% marks
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="spacer-double"></div>
			</div>
		</div>
	);
}

export default hero;